// extracted by mini-css-extract-plugin
export default {"video":"styles_video__blKtB"};